import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const EvaluationCriteria = (props) => {
	const {
		value,
		onChange,
		name,
		options = [],
		label,
	} = props;

	const handleEvaluationCriteriaChange = (e) => {
		onChange({ target: { name,  value: e.target.value }});
	};
 
	return (
		<div style={{display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'space-between' }}>
			<div>{label}</div>
			<FormControl sx={{minWidth: 200}}>
				<InputLabel id="demo-simple-select-label">Evaluation Criteria</InputLabel>
				<Select
					labelId="demo-simple-select-label"
					id="demo-simple-select"
					value={value}
					label="Evaluation Criteria"
					onChange={handleEvaluationCriteriaChange}
				>
					{options.map(({label, value}) => (
						<MenuItem key={value} value={value}>{label}</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>

	);
};

EvaluationCriteria.type = 'EvaluationCriteria';
EvaluationCriteria.spec = [{
	name: 'EvaluationCriteria',
	key: 'EvaluationCriteria',
	title: 'Evaluation Criteria',
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, 
	{
		type: 'repeater',
		label: 'Options',
		name: 'options',
		fields: [{
			type: 'TextField',
			htmlType: 'number',
			name: 'value',
			label: 'Value',
		}, {
			type: 'TextField',
			name: 'label',
			label: 'Label',
		}],
	}],
}];

export default EvaluationCriteria;